import React from 'react'

import GroupWrapper from '../../components/GroupWrapper'
import Flex from '../../../../../components/layouts/Flex'

import NewApplicantChart from './NewApplicantChart'
import ApplicationTypeChart from './ApplicationTypeChart'
import TotalApplicantPipelineChart from './TotalApplicantPipelineChart'
import RecruitmentTypeChart from './RecruitmentTypeChart'
import HiredApplicants from './HiredApplicants'
import HiredJobs from './HiredJobs'
import VacancyTypeChart from './VacancyTypeChart'

const MonthlyCharts = () => {
    return (
        <GroupWrapper title="Charts - Monthly">
            <Flex
                padding="0 1rem 1rem 1rem"
                direction="column"
                width="100%"
                height="50vh"
                justify="center"
                bB="1px solid #AEB3C9"
            >
                <NewApplicantChart />
            </Flex>
            <Flex
                padding="0 1rem 1rem 1rem"
                direction="column"
                width="100%"
                height="50vh"
                justify="center"
                bB="1px solid #AEB3C9"
            >
                <ApplicationTypeChart />
            </Flex>
            <Flex
                padding="0 1rem 1rem 1rem"
                direction="column"
                width="100%"
                height="50vh"
                justify="center"
                bB="1px solid #AEB3C9"
            >
                <TotalApplicantPipelineChart />
            </Flex>
            <Flex
                padding="0 1rem 1rem 1rem"
                direction="column"
                width="100%"
                height="50vh"
                justify="center"
                bB="1px solid #AEB3C9"
            >
                <RecruitmentTypeChart />
            </Flex>
            <Flex
                padding="0 1rem 1rem 1rem"
                direction="column"
                width="100%"
                height="50vh"
                justify="center"
                bB="1px solid #AEB3C9"
            >
                <HiredApplicants />
            </Flex>
            <Flex
                padding="0 1rem 1rem 1rem"
                direction="column"
                width="100%"
                height="50vh"
                justify="center"
                bB="1px solid #AEB3C9"
            >
                <HiredJobs />
            </Flex>
            <Flex
                padding="0 1rem 1rem 1rem"
                direction="column"
                width="100%"
                height="50vh"
                justify="center"
                bB="1px solid #AEB3C9"
            >
                <VacancyTypeChart />
            </Flex>
        </GroupWrapper>
    )
}

export default MonthlyCharts
